(() => {
  'use strict';
  const instances = new Map();
  const clamp = value => Math.min(1, Math.max(0, value));

  function createHero(hero) {
    const pin = hero.querySelector('[data-hero-pin]');
    if (!pin || !window.matchMedia || !window.requestAnimationFrame) return () => {};
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    const header = document.querySelector('.site-header');
    const water = hero.querySelector('[data-running-drops]');
    let frame = 0, measureNext = true, destroyed = false;
    let top = 0, distance = 1, enabled = false, pinned = false;

    function changeFlavor(event) {
      const input = event?.target || hero.querySelector('.hero-flavors input:checked');
      if (!input?.matches('.hero-flavors input[type="radio"]')) return;
      if (!['curacao', 'hibiskus'].includes(input.value)) return;
      hero.dataset.flavor = input.value;
      document.documentElement.dataset.mocksyFlavor = input.value;
      hero.querySelectorAll('[data-can-flavor]').forEach(can => can.setAttribute('aria-hidden', String(can.dataset.canFlavor !== input.value)));
      const surface = hero.querySelector('[data-can-flavor="' + input.value + '"] [data-water-surface]');
      if (water && surface) surface.appendChild(water);
      request();
    }

    function reset() {
      ['--world-y','--world-scale','--blue-y','--pink-y','--blue-turn','--pink-turn','--hero-progress'].forEach(name => hero.style.removeProperty(name));
    }
    function measure() {
      top = header ? header.getBoundingClientRect().height : 0;
      const available = window.innerHeight - top;
      const height = pin.offsetHeight;
      enabled = hero.dataset.scrollEnabled !== 'false' && !reduce.matches;
      // A tall mobile scene must scroll normally so every control stays reachable.
      pinned = enabled && height <= available + 1 && available >= 520;
      const percent = Math.min(80, Math.max(15, Number(hero.dataset.scrollLength) || 45));
      distance = pinned ? Math.round(available * percent / 100) : Math.max(1, height);
      hero.style.setProperty('--hero-top', top + 'px');
      hero.style.setProperty('--scene-height', height + 'px');
      hero.style.setProperty('--scroll-distance', distance + 'px');
      hero.classList.toggle('is-scroll-ready', pinned);
      if (!enabled) reset();
    }
    function render() {
      frame = 0;
      if (destroyed) return;
      if (measureNext) { measureNext = false; measure(); }
      const rect = hero.getBoundingClientRect();
      const visible = !document.hidden && rect.bottom > top && rect.top < window.innerHeight;
      hero.classList.toggle('is-water-running', visible && !reduce.matches);
      if (!enabled || !visible) return;
      const progress = clamp((top - rect.top) / distance);
      hero.style.setProperty('--hero-progress', progress.toFixed(4));
      hero.style.setProperty('--world-y', (-progress * 2.4).toFixed(3) + '%');
      hero.style.setProperty('--world-scale', (1.04 + progress * .025).toFixed(4));
      hero.style.setProperty('--blue-y', (-progress * 22).toFixed(2) + 'px');
      hero.style.setProperty('--pink-y', (progress * 16).toFixed(2) + 'px');
      hero.style.setProperty('--blue-turn', (-6 + progress * 10).toFixed(2) + 'deg');
      hero.style.setProperty('--pink-turn', (7 - progress * 12).toFixed(2) + 'deg');
    }
    function request() {
      if (!frame && !destroyed) frame = window.requestAnimationFrame(render);
    }
    function resize() { measureNext = true; request(); }
    window.addEventListener('scroll', request, { passive: true });
    window.addEventListener('resize', resize, { passive: true });
    document.addEventListener('visibilitychange', request);
    reduce.addEventListener('change', resize);
    hero.addEventListener('change', changeFlavor);
    const observer = window.ResizeObserver ? new window.ResizeObserver(resize) : null;
    observer?.observe(pin);
    if (header) observer?.observe(header);
    document.fonts?.ready.then(() => { if (!destroyed) resize(); });
    changeFlavor();
    request();
    return () => {
      destroyed = true;
      window.cancelAnimationFrame(frame);
      window.removeEventListener('scroll', request);
      window.removeEventListener('resize', resize);
      document.removeEventListener('visibilitychange', request);
      reduce.removeEventListener('change', resize);
      hero.removeEventListener('change', changeFlavor);
      observer?.disconnect();
      hero.classList.remove('is-scroll-ready');
      hero.classList.remove('is-water-running');
      delete document.documentElement.dataset.mocksyFlavor;
      reset();
    };
  }
  function init(root = document) {
    const heroes = [...root.querySelectorAll('[data-scroll-hero]')];
    if (root.matches?.('[data-scroll-hero]')) heroes.unshift(root);
    heroes.forEach(hero => { if (!instances.has(hero)) instances.set(hero, createHero(hero)); });
  }
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    instances.forEach((destroy, hero) => {
      if (event.target === hero || event.target.contains(hero)) { destroy(); instances.delete(hero); }
    });
  });
})();
